const UserNotificationType = {
  Generic: 'Generic',
  NewReviewOpportunity: 'NewReviewOpportunity',
  NewReviewReceived: 'NewReviewReceived',
  NewGoogleReviewConverted: 'NewGoogleReviewConverted',
  SubscriptionRenewal: 'SubscriptionRenewal',
  MemberInviteAccepted: 'MemberInviteAccepted',
  MemberInviteReceived: 'MemberInviteReceived',
} as const;

type UserNotificationType = (typeof UserNotificationType)[keyof typeof UserNotificationType];

export { UserNotificationType };
